<template>
    <div class="md:max-w-7xl md:mx-auto">
      <portal to="quickActions" >
        <div>
          <inertia-link :href="route('admin.reports')" class="border px-2 py-1 bg-white rounded">Product Items in Orders</inertia-link>
        </div>
      </portal>

      <h1 class="text-lg">Product Searching Terms</h1>
        <table class="w-auto mt-10">
            <thead class="text-sm">
            <tr class="border bg-white">
                <th class="py-2 border px-8">Search Term</th>
                <th class="py-2 border px-8">Hits</th>
                <th class="py-2 border px-8">Result Shown</th>
            </tr>

            </thead>
            <tbody>
            <tr v-for="row in report" class="border border-b bg-white text-sm">
                <td class="px-8 py-2">{{ row.search_term }}</td>
                <td class="px-2 py-2 text-center">{{ row.hits }}</td>
                <td class="px-2 py-2 text-center">
                  <span v-if="row.has_result" class="bg-green-300 px-2 py-1 text-green-900">Yes</span>
                  <span v-else class="bg-yellow-100 px-2 py-1 text-yellow-800">No</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import Layout from '@/Shared/Admin/Layout'

  export default {
    name: 'ProductOrderQtyReport',
    metaInfo: { title: 'Reports' },
    layout: Layout,
    props: {
      report: Array
    }
  }
</script>
